export default __webpack_public_path__ + "static/media/metamask.d48ff7e9.svg";